import {
  CheckCircle,
  Server,
  Shield,
  Brain,
  MessageSquare,
  Search,
  FileText,
  ClipboardCheck,
  Building,
  Award,
  Laptop,
  Heart,
  DollarSign,
  Factory,
  Landmark,
  Briefcase,
  ChevronRight,
  Phone,
  Mail,
  MapPin,
  Menu,
  X,
  ChevronDown,
  Star,
  Users,
  Globe,
  Target,
  TrendingUp,
  BookOpen,
  Download,
  Calendar,
  Clock,
  ArrowRight
} from 'lucide-react';

export const iconComponents = {
  CheckCircle,
  Server,
  Shield,
  Brain,
  MessageSquare,
  Search,
  FileText,
  ClipboardCheck,
  Building,
  Award,
  Laptop,
  Heart,
  DollarSign,
  Factory,
  Landmark,
  Briefcase,
  ChevronRight,
  Phone,
  Mail,
  MapPin,
  Menu,
  X,
  ChevronDown,
  Star,
  Users,
  Globe,
  Target,
  TrendingUp,
  BookOpen,
  Download,
  Calendar,
  Clock,
  ArrowRight
};

export const getIcon = (iconName) => {
  return iconComponents[iconName] || CheckCircle;
};
